import React, { useState } from "react";
import { NearbyLocationWithSlots } from "../../../../hooks/urgent-visit/useNearbyHospitalSlots";
import { TimeSlotGrid } from "./TimeSlotGrid";
import Loading from "../../../../components/Loading/Loading";
import CheveronDownSmallIcon from "../../../../components/Icons/CheveronDownSmallIcon";
import { InfoIcon } from "../../../../components/Icons";
import { IOptionGeneric } from "../../../interface";

interface NearbyHospitalCardProps {
  data: NearbyLocationWithSlots;
  homeLocationName: string;
  selectedSlotValue: string | null;
  selectedLocationId: string | null;
  onSlotSelect: (slot: IOptionGeneric, locationData: NearbyLocationWithSlots) => void;
}

export const NearbyHospitalCard = ({
  data,
  homeLocationName,
  selectedSlotValue,
  selectedLocationId,
  onSlotSelect,
}: NearbyHospitalCardProps) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const distance = data.location.totalDistance;

  const handleSlotSelect = (slot: IOptionGeneric) => {
    onSlotSelect(slot, data);
  };

  return (
    <div className="border border-taupe-15 bg-taupe-15 rounded-xl overflow-hidden">
      <button
        type="button"
        className="w-full flex justify-between items-center p-4 cursor-pointer bg-transparent border-none text-left"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex flex-col gap-0.5">
          <span className="grenette-pro font-semibold text-base text-light-black">
            {data.location.locationName}
          </span>
          {distance != null && (
            <span className="text-xs text-gray-1">
              {`${distance} miles from ${homeLocationName}`}
            </span>
          )}
        </div>
        <div className={`transition-transform duration-200 ${isExpanded ? "rotate-180" : ""}`}>
          <CheveronDownSmallIcon color="#DAD7D6" />
        </div>
      </button>

      {isExpanded && (
        <div className="px-4 pb-4">
          {data.loading ? (
            <div className="flex justify-center py-4">
              <Loading />
            </div>
          ) : data.timeSlots.length ? (
            <TimeSlotGrid
              gridId={`nearby-${data.location.idLocation}`}
              slots={data.timeSlots}
              selectedValue={
                selectedLocationId === data.location.idLocation ?
                  selectedSlotValue : null
              }
              onSelect={handleSlotSelect}
              columns={3}
              maxVisible={6}
            />
          ) : (
            <div className="flex gap-2 border border-gv-yellow bg-gv-yellow-light p-3 rounded-lg items-center">
              <InfoIcon width={20} height={20} />
              <span className="text-sm text-light-black">
                {"There is no availability for this date."}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
